import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StreetAddressField = () => {
    const value = useBrokerDetailsStore((s) => s.homeAddress.street1);
    const updateHomeAddress = useBrokerDetailsStore((s) => s.updateHomeAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.HomeStreet1);

    return (
        <>
            <TextBox
                id='hAddress1'
                value={value}
                onChange={(v) => updateHomeAddress({ street1: v })}
                width={'100%'}
                label='Street Address'
                required={isBroker}
                placeholder='Street number and name'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon icon={'asterisk'} className='required-icon' />
            </ShowIf>
        </>
    );
};
